<template>
<transition name="slide">
    <div class="task-info-footer" v-if="open" v-cloak>
        <div class="transfer-detail-title">{{$t('language.popup.transferDetails')}}</div>
        <div class="transfer-status-des">
            <div style="float:left;">{{$t('language.common.from')}}:</div>
             <div style="cursor:pointer;" v-show="itemDetail.sourceCloudType==='Shares'" class="catelog-color transfer-detail-max" @click.stop="toShareCatalog(itemDetail)" :title="itemDetail.sourceNode|getCatalogShare|getCatalogTitle">{{itemDetail.sourceNode|getCatalogShare}}</div>
            <div style="cursor:pointer;"  v-show="itemDetail.sourceCloudType!=='Shares'"  class="catelog-color transfer-detail-max" @click.stop="toSourceCatalog(itemDetail)" :title="itemDetail.sourceNode|getCatalog|getCatalogTitle">{{itemDetail.sourceNode|getCatalog}}</div>
        </div>
        <div class="transfer-status-des">
            <div style="float:left;">{{$t('language.common.to')}}:</div>
            <div style="cursor:pointer;" class="catelog-color transfer-detail-max" @click.stop="toAimSourceCatalog(itemDetail)" :title="itemDetail.desNode|getCatalog|getCatalogTitle">{{itemDetail.desNode|getCatalog}}</div>
        </div>
        <div class="transfer-status-des">
            <span>{{$t('language.common.fileProcess')}}:{{itemDetail.readyTranFileCount}}/{{itemDetail.totalFileCount}}</span>
            <span class="transfer-success-progress">{{$t('language.common.dataProcess')}}:{{itemDetail.readedBytes|formatByte}}/{{itemDetail.totalBytes|formatByte}}</span>
        </div>
        <div class="transfer-status-des">
            <span>{{$t('language.common.startTime')}}:{{itemDetail.taskStartTimeLong|transferForMatTime}}</span>
            <span class="transfer-success-progress">{{$t('language.common.endTime')}}:{{itemDetail|getEndTime}}</span>
        </div>
        <div class="transfer-status-des">{{$t('language.common.averageRate')}}:{{(itemDetail.readedBytes/(itemDetail.taskElaspedTimeLong/1000))|formatByteSpeed}}</div>
        <div class="transfer-success-footer" v-if="(itemDetail.readedBytes==itemDetail.totalBytes)&&itemDetail.totalBytes!=0">
            {{$t('language.common.fileSuccess')}}
        </div>
    </div>
</transition>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
export default {
    props: ['open', 'index', 'itemDetail'],
    data: function () {
        return {

        }
    },
    methods: {
        toSourceCatalog(itemDetail) {
            let that = this;
            this.$parent.$parent.$parent.isflage = true;
            let direction = that.$parent.$parent.$parent.$parent.$parent;
            commonUtils.toSourceCatalog(itemDetail, this, function (res) {
                if (res.status == 200) {
                        let pathData = that.$store.state.pathJson[res.id + itemDetail.sourceToken];
                        const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
                        if (!pathData || !pathData.json.length) {
                            $.each(itemDetail.sourceNode,function(i,item){
                                  item.tokenId=itemDetail.sourceToken;
                            });
                            commonUtils.encapsulationPath(itemDetail.sourceNode, pathData, vm);
                        } else {
                            vm.pathJson = pathData.json;
                        }
                        commonUtils.selectOption(itemDetail.sourceNode, direction);
                        that.$store.state.catalogFileId = itemDetail.sourceNode[0].fileId;
                        commonUtils.ifHasDataSelect(vm);
                }
            });
        },
        toAimSourceCatalog(itemDetail) {
            let that = this;
            this.$parent.$parent.$parent.isflage = true;
            let direction = this.$parent.$parent.$parent.$parent.$parent;
            commonUtils.toAimSourceCatalog(itemDetail, this, function (res) {
                if (res.status == 200) {
                        commonUtils.selectOption(itemDetail.desNode, direction);
                        let pathData = that.$store.state.pathJson[res.id + itemDetail.desToken];
                        const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
                        if (!pathData || !pathData.json.length) {
                            commonUtils.encapsulationPath(itemDetail.desNode, pathData, vm);
                        } else {
                            vm.pathJson = pathData.json;
                        }
                }
            });
        },
        toShareCatalog(itemDetail){
            let allNodes = itemDetail.sourceNode;
            let nodes = commonUtils.getSharePathForCryptId(itemDetail);
            if(nodes){
                this.$store.commit("setSharePath", nodes);
            }
            let link = commonstate.sharePageUrl + allNodes[allNodes.length-1].shareId;
            window.open(link);
        },
    }
}
</script>

<style>
.slide-enter-active {
    transition: all 0.3s ease;
    height:100Px;
    overflow: hidden;
}

.slide-leave-active {
  transition: all 0s ease;
    height: 0;
    /*no*/
    overflow: hidden;
}

.slide-enter,
.slide-leave {
    height: 0;
    opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_detailed_progress/tab_success_detail.vue